export const canCopyNodeId = () => () => {
    return function (node) {
        const {bizNodeType} = node.data
        return this.BizNode[bizNodeType].classes.includes('product')
    }
}

export const copyNodeId = () => () => {
    return async function (nodes) {
        if (0 === nodes.length) {
            return
        }

        const text = [...nodes]
            .map(node => {
                const {bizNodeType, dpSn, rev, sVer} = node.data
                const text = this.BizNode[bizNodeType].getTextRaw(this, node)
                return [dpSn, `${sVer}.${rev}`, text].join('/')
            })
            .join('\n')

        await navigator.clipboard.writeText(text)
        this.logger.info('节点标识已拷贝到剪贴板', nodes)
    }
}
